<template>
  <b-card>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >
      <b-button
        v-if="$can('write', 'dispatch-configurations')"
        variant="primary"
        class="mb-1"
        @click="$router.push('/dispatch-configurations/new')"
      >
        Add Dispatch Configuration
      </b-button>
      <b-table
        :fields="tableColumns"
        :items="data"
        :current-page="page"
        :per-page="perPage"
        responsive
        show-empty
        empty-text="No matching records found"
        striped
        hover
        @row-clicked="viewDispatchConfig"
      />
      <BasePagination
        v-model="page"
        :total="data.length"
        @new-per-page="perPage = $event"
      />
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton,
} from 'bootstrap-vue'
import useList from '../hooks/useList'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import dispatchStore from '../store'
import BasePagination from '@/UI/BasePagination.vue'

export default {
  components: {
    BCard,
    BTable,
    BOverlay,
    BasePagination,
    BButton,
  },
  setup(_, ctx) {
    useRegisterStoreModule('dispatch', dispatchStore)
    return {
      ...useList(ctx),
    }
  },
}
</script>

<style>

</style>
